import { useMemo } from "react";
import { TotalRevenuePanelProps } from "./TotalRevenuePanel.types";
import { isToday } from "date-fns";
import { useRefreshRegister } from "../../components/RefreshProvider";
import { usePostTotalRevenueQuery } from "../../app/useGeneratedApi";
import { getLastPeriod } from "../../utils/dateUtils";

export function useTotalRevenuePanel(props: TotalRevenuePanelProps) {
  const { from, to } = props;

  const {
    data: totalRevenueData,
    refetch,
    isLoading: isLoadingStatistics,
    error,
  } = usePostTotalRevenueQuery({
    from,
    to,
  });

  useRefreshRegister(async () => {
    await refetch();
  });

  const statistics = useMemo(() => {
    return (
      totalRevenueData || {
        campaignRevenue: {
          currentRevenue: 0,
          previousRevenue: 0,
          comparePercent: 0.0,
        },
        workflowRevenue: {
          currentRevenue: 0,
          previousRevenue: 0,
          comparePercent: 0.0,
        },
        totalRevenue: {
          currentRevenue: 0,
          previousRevenue: 0,
          comparePercent: 0.0,
        },
        compareDays: 0,
      }
    );
  }, [totalRevenueData]);

  const campaignPercentage = useMemo(() => {
    const total = statistics.totalRevenue.currentRevenue || 0;
    const campaign = statistics.campaignRevenue.currentRevenue || 0;
    return total > 0 ? (campaign / total) * 100 : 0;
  }, [statistics]);

  const workflowPercentage = useMemo(() => {
    const total = statistics.totalRevenue.currentRevenue || 0;
    const workflow = statistics.workflowRevenue.currentRevenue || 0;
    return total > 0 ? (workflow / total) * 100 : 0;
  }, [statistics]);

  return {
    statistics,
    isLoadingStatistics,
    error,
    campaignPercentage,
    workflowPercentage,
    lastPeriod: isToday(to || new Date())
      ? getLastPeriod(statistics.compareDays || 0)
      : "period",
  };
}
